


















import { Component, Prop, Vue } from 'vue-property-decorator'
import { isObjectEmpty } from '@/utils'

@Component
export default class Radio extends Vue {
  @Prop([Number, String]) value!: any

  @Prop({
    type: Object,
    required: true
  }) field!: any

  @Prop({
    type: Array,
    required: true
  }) data!: any

  private currentValue: number = Number(this.value)
  
  // __METHODS
  private change (val: any): void {
    if (!isObjectEmpty(val)) {
      this.currentValue = val.id
      this.$emit('input', this.currentValue)
    }
  }
}
